module.exports = __webpack_public_path__ + "ccdf5989e3eea138b2a685bb3e7e8ff0.png";